import { type TransactionHash, type TokenId, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const DEPOSIT_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.DEPOSIT}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface DepositSuccessPayload {
    transactionHash: TransactionHash;
    depositTokenId: TokenId;
    depositAmount: number;
}

export interface DepositEventPayloads extends Record<string, unknown> {
    [DEPOSIT_EVENTS.SUCCESS]: DepositSuccessPayload;
}

export const depositEventEmitter = createEventEmitter<DepositEventPayloads>();
